import * as benchlingUtil from 'BenchlingUtil';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import EditorRoutes from 'foundation/EditorRoutes';
import printerFriendlyViewHandler from 'routing/printerFriendlyViewHandler';
import {RouteBundle} from 'routing/RouteConstants';
import APIUtil from 'util/APIUtil';

export const NotebookRoutes: RouteBundle = {
  domain: 'notebook',
  routes: [
    {
      urlPattern: 'entry-review-processes',
      handler: EditorRoutes.reviewLifecyclesListing.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 'entry-review-processes/configuration', handler: reviewLifecycleConfiguration, legacy: true},
    {
      urlPattern: 'entry-review-processes/:reviewLifecycleId',
      handler: reviewLifecycleConfiguration,
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/template-collections/',
      handler: EditorRoutes.templateCollections.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/template-collections/:collectionId',
      handler: EditorRoutes.templateCollection.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/f/:folderIdentifier/:itemUrlIdentifier/view',
      handler: printerFriendlyViewHandler,
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/templates/:templateUrlIdentifier/view',
      handler: printerFriendlyViewHandler,
      legacy: true,
    },
    {urlPattern: ':currentUserUrl/templates/:templateUrlIdentifier', handler: templateEditor, legacy: true},
    {
      urlPattern: ':currentUserUrl/subtemplates/:subtemplateUrlIdentifier',
      handler: subtemplateEditor,
      legacy: false,
    },
    {
      urlPattern: ':currentUserUrl/subtemplates/:subtemplateUrlIdentifier/view',
      handler: printerFriendlyViewHandler,
      legacy: false,
    },
    {
      urlPattern:
        'preview/:owningEntityApiId/:noteLinkedFileId/:id/:encodedName/:isPreviewTransformed/:previewType/:encodedUrl/:encodedSourceUrl/:encodedAvailablePreviewTypes',
      handler: renderAttachmentPreviewPage,
      legacy: false,
    },
  ],
};

function reviewLifecycleConfiguration(reviewLifecycleId?: string): void {
  EditorRoutes.reviewLifecycleConfiguration(reviewLifecycleId);
}

function templateEditor(userId: string, templateUrlIdentifier: string): void {
  const {queryKey} = benchlingUtil.parseUri(window.location.href);
  const versionId = queryKey.versionId != null ? parseInt(queryKey.versionId, 10) : undefined;
  EditorRoutes.templateEditor(
    userId,
    APIUtil.withPrefixIfMissing(templateUrlIdentifier, ModelTypeConstants.TEMPLATE),
    {
      versionId,
    }
  );
}

function subtemplateEditor(userId: string, subtemplateUrlIdentifier: string): void {
  EditorRoutes.subtemplateEditor(
    userId,
    APIUtil.withPrefixIfMissing(subtemplateUrlIdentifier, ModelTypeConstants.SUBTEMPLATE)
  );
}

function renderAttachmentPreviewPage(
  owningEntityApiId: string,
  noteLinkedFileId: string,
  id: string,
  encodedName: string,
  isPreviewTransformed: string,
  previewType: EXTERNAL_FILE_TYPE,
  encodedUrl: string,
  encodedSourceUrl: string,
  encodedAvailablePreviewTypes: string
): void {
  EditorRoutes.attachmentPreviewPage(
    owningEntityApiId,
    noteLinkedFileId,
    id,
    encodedName,
    isPreviewTransformed,
    previewType,
    encodedUrl,
    encodedSourceUrl,
    encodedAvailablePreviewTypes
  );
}
